/**
 * cputools workspace (Brief 185) — ONE page for every compute utility, NOT a
 * page per tool. Category tabs (PDF / Media / Doc / CSV / Image / Data) over the
 * run history, which is the activity stream filtered to that category's
 * service-key prefix. cputools is stateless, so the ledger IS the run history.
 */
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ActivityStream } from '@/components/ActivityStream';

const CATEGORIES: Array<{ key: string; label: string; prefix: string }> = [
  { key: 'pdf', label: 'PDF', prefix: 'pdf.' },
  { key: 'media', label: 'Media', prefix: 'media.' },
  { key: 'doc', label: 'Doc', prefix: 'doc.' },
  { key: 'csv', label: 'CSV', prefix: 'csv.' },
  { key: 'image', label: 'Image', prefix: 'image.' },
  { key: 'data', label: 'Data', prefix: 'data.' },
];

export function CputoolsWorkspace() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">Compute &amp; convert</h1>
        <p className="text-muted-foreground">
          Pure-compute utilities billed per call. Pick a category to see your run
          history — each row is a billed conversion.
        </p>
      </header>

      <Card>
        <CardHeader>
          <CardTitle>Run history</CardTitle>
          <CardDescription>cputools is stateless — your ledger is the record of every run.</CardDescription>
        </CardHeader>
        <CardContent>
          <Tabs defaultValue="pdf">
            <TabsList className="flex flex-wrap">
              {CATEGORIES.map((c) => (
                <TabsTrigger key={c.key} value={c.key}>
                  {c.label}
                </TabsTrigger>
              ))}
            </TabsList>
            {CATEGORIES.map((c) => (
              <TabsContent key={c.key} value={c.key} className="pt-4">
                <ActivityStream baseQuery={{ servicePrefix: c.prefix }} />
              </TabsContent>
            ))}
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
}
